import { CSSResultGroup, html, nothing, TemplateResult } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
import { OutlineElement } from '../../base/outline-element/outline-element';
import componentStyles from './ghs-newsletter.css.lit';
import { classMap } from 'lit/directives/class-map.js';
import '../ghs-heading/ghs-heading';

/**
 * Newsletter Component
 * @element ghs-newsletter
 */
@customElement('ghs-newsletter')
export class GhsNewsletter extends OutlineElement {
  static styles: CSSResultGroup = [componentStyles];

  /**
   * Set to 'true' to center content items.
   */
  @property({ type: Boolean })
  centered = false;

  /**
   * The heading text.
   * @param heading
   */
  @property({ type: String })
  heading = '';

  @state() hasFooterSlot = false;

  firstUpdated(): void {
    super.firstUpdated();
    this.hasFooterSlot = this.querySelector('[slot="footer"]') !== null;
  }

  // @ts-expect-error ignore TS error.
  handleSlotchange(e) {
    const childNodes = e.target.assignedNodes({ flatten: true });
    const childNode = childNodes.find(
      (node: { tagName: string }) => node?.tagName == 'GHS-FORM'
    );

    if (childNode) {
      const hasInlineClassForm = childNode
        .querySelector('form')
        ?.classList?.contains('inline');

      if (!hasInlineClassForm) {
        // Force actions elements to have a centered alignment.
        childNode.setAttribute('actions-alignment', 'center');
      }
    }
  }

  render(): TemplateResult {
    const classes = {
      'newsletter': true,
      'newsletter--centered': this.centered,
      'newsletter--has-footer': this.hasFooterSlot,
    };

    return html`
      <div class="${classMap(classes)}">
        <div class="container">
          <ghs-heading
            class="title"
            level="h2"
            level-style="bold"
            site=${this.site}
          >
            ${this.heading}
          </ghs-heading>

          <slot @slotchange=${this.handleSlotchange}></slot>
        </div>
        ${this.hasFooterSlot
          ? html`
              <hr class="line" />
              <div class="container">
                <slot name="footer"></slot>
              </div>
            `
          : nothing}
      </div>
    `;
  }
}
